/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_Card_EmptyInputs */

const en_us2_exercise_personal_strength_card_empty = /** @type {(inputs: Exercise_Personal_Strength_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None of the lifts you've logged has a published standard yet.`)
};

const pt_br2_exercise_personal_strength_card_empty = /** @type {(inputs: Exercise_Personal_Strength_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum dos exercícios que você registrou tem referência de força publicada ainda.`)
};

const es_419_exercise_personal_strength_card_empty = /** @type {(inputs: Exercise_Personal_Strength_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguno de los ejercicios que registraste tiene todavía una referencia de fuerza publicada.`)
};

const pt_pt2_exercise_personal_strength_card_empty = /** @type {(inputs: Exercise_Personal_Strength_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum dos exercícios que registaste tem ainda uma referência de força publicada.`)
};

const fr_fr2_exercise_personal_strength_card_empty = /** @type {(inputs: Exercise_Personal_Strength_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun des exercices que tu as enregistrés n'a encore de norme publiée.`)
};

const de_de2_exercise_personal_strength_card_empty = /** @type {(inputs: Exercise_Personal_Strength_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für keine deiner eingetragenen Übungen gibt es bisher einen veröffentlichten Standard.`)
};

const it_it2_exercise_personal_strength_card_empty = /** @type {(inputs: Exercise_Personal_Strength_Card_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno degli esercizi che hai registrato ha ancora uno standard di forza pubblicato.`)
};

/**
* | output |
* | --- |
* | "None of the lifts you've logged has a published standard yet." |
*
* @param {Exercise_Personal_Strength_Card_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_card_empty = /** @type {((inputs?: Exercise_Personal_Strength_Card_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_Card_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_card_empty(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_card_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_card_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_card_empty(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_card_empty(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_card_empty(inputs)
	return en_us2_exercise_personal_strength_card_empty(inputs)
});
export { exercise_personal_strength_card_empty as "exercise-personal.strength_card_empty" }